import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

export const getSupplierFacilitiesListQueryKey = () =>
  ['supplierFacilities', 'list'] as const;
export type SupplierFacilitiesListQueryKey = ReturnType<
  typeof getSupplierFacilitiesListQueryKey
>;

export const useSupplierFacilitiesList: QueryFunction<
  any[],
  [],
  SupplierFacilitiesListQueryKey
> = ({ requestOptions, queryOptions } = {}) => {
  const queryKey = getSupplierFacilitiesListQueryKey();
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request('/suppliers/supplier_facilities', {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
